module.exports = __webpack_public_path__ + "static/img/btn.8db8e62f.png";